export default __webpack_public_path__ + "static/media/howies.8a9730f8.png";